/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectQueryInput
 */
export interface ProjectQueryInput {
    /**
     * 
     * @type {string}
     * @memberof ProjectQueryInput
     */
    searchString: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectQueryInput
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectQueryInput
     */
    limit: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectQueryInput
     */
    sortProperty: ProjectQueryInputSortPropertyEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectQueryInput
     */
    sortOrder: ProjectQueryInputSortOrderEnum;
}


/**
 * @export
 */
export const ProjectQueryInputSortPropertyEnum = {
    LastUpdateSort: 'lastUpdateSort',
    CreatedDate: 'createdDate',
    UploadSizeSort: 'uploadSizeSort',
    ProcessedSizeSort: 'processedSizeSort'
} as const;
export type ProjectQueryInputSortPropertyEnum = typeof ProjectQueryInputSortPropertyEnum[keyof typeof ProjectQueryInputSortPropertyEnum];

/**
 * @export
 */
export const ProjectQueryInputSortOrderEnum = {
    Empty: '',
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ProjectQueryInputSortOrderEnum = typeof ProjectQueryInputSortOrderEnum[keyof typeof ProjectQueryInputSortOrderEnum];


/**
 * Check if a given object implements the ProjectQueryInput interface.
 */
export function instanceOfProjectQueryInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "searchString" in value;
    isInstance = isInstance && "offset" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "sortProperty" in value;
    isInstance = isInstance && "sortOrder" in value;

    return isInstance;
}

export function ProjectQueryInputFromJSON(json: any): ProjectQueryInput {
    return ProjectQueryInputFromJSONTyped(json, false);
}

export function ProjectQueryInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectQueryInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchString': json['searchString'],
        'offset': json['offset'],
        'limit': json['limit'],
        'sortProperty': json['sortProperty'],
        'sortOrder': json['sortOrder'],
    };
}

export function ProjectQueryInputToJSON(value?: ProjectQueryInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchString': value.searchString,
        'offset': value.offset,
        'limit': value.limit,
        'sortProperty': value.sortProperty,
        'sortOrder': value.sortOrder,
    };
}

